import "../index.js";
import type {ExtendedPromise, OttoNexus} from "@otto-ec/global-resources/nexus";
import type {NativeShareOptions} from "./shareNative.js";
import {apps} from "../index.js";

export type SharingRaw = {
    /**
 *
 *
 */
    shareNative(data: NativeShareOptions): ExtendedPromise;
}

export type Sharing = OttoNexus["apps"]["sharing"]

/**
 *
 */
export const sharing: Sharing = apps.sharing;

/**
 *
 */
export const shareNative: Sharing["shareNative"] = sharing.shareNative;